import { useState, useEffect } from 'react';
import TurmaTableSelected from '../Turma/TurmaTableSelect';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TurmaProfile from '../Turma/TurmaProfile';
import { findUnregisteredDisciplinas, save, findByTurma, registerNBAndCA } from './api-tdp';
import DisciplinaTurmaTable from './DisciplinaTurmaTable';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import { Button, Grid } from '@mui/material';
import DisciplinaTurmaForm from './DisciplinaTurmaForm';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import Loading from '../UI/Loading';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    container: {
        paddingTop: '10px',
        paddingBottom: '10px'
    }
})

export default function DisciplinaTurmaContainer() {
    const classes = useStyles();
    const [tdp, setTdp] = useState(null);
    const [tdps, setTdps] = useState([]);
    const [isLoadingTdps, setIsLoadingTdps] = useState(false);
    const [loadingAdicionarDisciplina, setLoadingAdicionarDisciplina] = useState(false);
    const [turma, setTurma] = useState(null);
    const [unregisteredDisciplinas, setUnregisteredDisciplinas] = useState([]);

    useEffect(() => {
        if (turma) {
            findUnregisteredDisciplinas(turma.codigo).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setUnregisteredDisciplinas(data);
                }
            });

            setIsLoadingTdps(true);
            findByTurma(turma.codigo).then((data) => {
                if (data) {
                    if (data.error) {
                        errorMessage(data.message);
                    } else {
                        setTdps(data);
                    }
                }
                setIsLoadingTdps(false);
            });
        } else {
            setTdp(null);
        }
    }, [turma]);

    const handleSaveNoBimestreError = () => {
        confirmAlert({
            title: 'Erro',
            message: 'A série para esta turma não possui cadastro de bimestres. Cadastre os bimestres antes de inserir disciplina na turma.',
            buttons: [
                {
                    label: 'Ok',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleSaveTurmaAndDisciplinaAlreadyRegistered = () => {
        confirmAlert({
            title: 'Erro',
            message: 'Disciplina já cadastrada para a Turma.',
            buttons: [
                {
                    label: 'Ok',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleAdicionarDisciplina = (e) => {
        e.preventDefault();


        if (!tdp.disciplina) {
            toast.error("Selecione uma disciplina.", {
                position: "bottom-left"
            });
            return;
        }
        setLoadingAdicionarDisciplina(true);
        const eNovo = tdp.eNovo;
        save(tdp).then(data => {
            if (data.error) {
                if (data.message === 'Erro: Bimestre nao cadastrado') {
                    handleSaveNoBimestreError();
                } else if (data.message === 'Erro: Turma and Disciplina already registered') {
                    handleSaveTurmaAndDisciplinaAlreadyRegistered();
                }
                else {
                    errorMessage(data.message);
                }
            } else {
                toast.success("Salvo com sucesso.", {
                    position: "bottom-left"
                });
                setTdp(data);
                if (eNovo) {
                    setTdps([
                        ...tdps,
                        data
                    ]);
                    setUnregisteredDisciplinas(
                        unregisteredDisciplinas.filter((d) => (
                            d.codDisciplina !== data.disciplina.codDisciplina
                        ))
                    );
                } else {
                    setTdps((prevState) => prevState.map((ps) => {
                        if (ps.codigo === data.codigo) {
                            return data;
                        } else {
                            return ps;
                        }
                    }));
                }

                setLoadingAdicionarDisciplina(false);
            }
        });
    }

    const handleRegisterNBAndCA = () => {
        setLoadingAdicionarDisciplina(true);
        registerNBAndCA(tdp.codigo).then(data => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    toast.success("Registro realizado com sucesso.", {
                        position: "bottom-left"
                    });
                    setLoadingAdicionarDisciplina(false);
                }
            }
        });
    }

    const handleTrocaTurma = () => {
        setTurma(null);
    }

    return (
        <Container className={classes.container} component={Paper}>
            <Grid container spacing={3} direction='column'>
                <Grid>
                    <Typography variant="h6">
                        Disciplina Turma
                    </Typography>
                </Grid>
                {turma ?
                    <>
                        <Grid>
                            <TurmaProfile turma={turma} handleTrocaTurma={handleTrocaTurma} />
                        </Grid>
                        {tdp ?
                            <Grid>
                                <DisciplinaTurmaForm
                                    tdp={tdp}
                                    setTdp={setTdp}
                                    handleAdicionarDisciplina={handleAdicionarDisciplina}
                                    handleRegisterNBAndCA={handleRegisterNBAndCA}
                                    loadingAdicionarDisciplina={loadingAdicionarDisciplina}
                                    unregisteredDisciplinas={unregisteredDisciplinas}
                                    setTdps={setTdps}
                                    tdps={tdps}
                                />
                            </Grid> :
                            <>
                                {isLoadingTdps ?
                                    <Grid>
                                        <Loading description="Carregando Turma-Disciplinas..." />
                                    </Grid> :
                                    <>
                                        <Grid>
                                            <Button variant='outlined' onClick={() => setTdp({
                                                eNovo: true,
                                                turma: turma,
                                                eDataSerie: true
                                            })}>
                                                Novo Registro
                                            </Button>
                                        </Grid>
                                        <Grid>
                                            <DisciplinaTurmaTable tdps={tdps} setTdp={setTdp} />
                                        </Grid>
                                    </>
                                }

                            </>
                        }

                    </> : (
                        <Grid>
                            <TurmaTableSelected onTurmaSelected={setTurma} />
                        </Grid>
                    )
                }
            </Grid>
        </Container>
    );
}